module.exports = __webpack_public_path__ + "static/media/ic_salidas.1b5e5d13.png";